import { NgModule } from '@angular/core';

import { RedirectServiceModule } from '@fcom/common-booking/modules/redirect-service';

import { MmbOrderService, OrderPreviewsService } from './services';

@NgModule({
  imports: [RedirectServiceModule],
  exports: [],
  declarations: [],
  providers: [MmbOrderService, OrderPreviewsService],
})
export class MmbOrderModule {}
